/* istanbul ignore file */
import { number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { User } from './User';
const EntryOverviewEntryParser = /* #__PURE__ */ parsers.object([
    ['user', User],
    ['useCount', codecNumber, 'use_count'],
    ['overrideLimit', /* #__PURE__ */ parsers.maybeNull(codecNumber), 'override_limit'],
]);
export class EntryOverviewEntry extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return EntryOverviewEntryParser.decode(input).map(res => new EntryOverviewEntry(res));
    }
    static unsafeDecode(input) {
        return EntryOverviewEntry.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return EntryOverviewEntryParser.encode(data);
    }
    static schema() {
        return EntryOverviewEntryParser.schema();
    }
}
